/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import {createSelector} from 'reselect';
import {createDeepEqualSelector} from '@ion/applications/src/store/selectors/SelectorUtils';
import {User} from '@ion/core/src/types/entities';
import {ApplicationState} from '@/types/redux';

const selectUser = ({login}) => login.user;

export const userSelector = createDeepEqualSelector(selectUser,
  (user: User): User => user
);

export const selectAuthenticated     = ({login: {authenticated}}: ApplicationState) => authenticated;
export const selectHasPreviewFeature = ({login: {hasPreviewFeature}}: ApplicationState) => hasPreviewFeature;
export const selectIsLoggingOut      = ({login: {isAuthenticating}}: ApplicationState) => isAuthenticating;
export const loginErrorMessage       = ({login: {loginErrorMessage}}: ApplicationState) => loginErrorMessage;

export const isAuthenticatedSelector = createSelector(selectAuthenticated,
  (authenticated: boolean): boolean => authenticated
);

export const hasPreviewFeatureSelector =
  createSelector([selectHasPreviewFeature], (hasPreviewFeature) => (hasPreviewFeature));

export const isLoggingOutSelector      =
  createSelector([selectIsLoggingOut], (isLoggingOut) => (isLoggingOut));

export const loginErrorMessageSelector = createSelector([loginErrorMessage], (loginError) => (loginError));
